/**
 * 이름 : fdpChartBubble
 * 설명 : bubble chart
 * 최종 수정 일시 : 2019 - 04 - 01
 * 제공 :
 *  - reactiveProp :
 *     > chart.js 를 활용하는 부모에서 chart의 prop 변경 시, 동적으로 chart 변경 제공
 *  - event :
 *     > render 는 chart 랜더링 완료 후 호출
 *     > destroy 는 chart 컴포넌트 해제 후 호출
 *     > update 는 re-render 호출 시 호출
 */
import { Bubble, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: 'sui-chart-bubble',
  extends: Bubble,
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
